module.exports = __webpack_public_path__ + "img/2.7b4c2db8.png";